import { render, staticRenderFns } from "./NotificationBarItem.vue?vue&type=template&id=418bf37c&scoped=true"
import script from "./NotificationBarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationBarItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NotificationBarItem.vue?vue&type=style&index=0&id=418bf37c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418bf37c",
  null
  
)

export default component.exports